/**
 * CTR Main Blog Article
 * Adds the product block to the cart without leaving the article, then opens the cart drawer.
 */

(function () {
  const SECTION_SELECTOR = '.ctr-main-blog-article';
  const FORM_SELECTOR = '[data-ctr-mba-atc-form]';

  function openCartDrawer() {
    const cart = document.querySelector('nood-cart');
    if (cart && typeof cart.open === 'function') {
      cart.open();
      return true;
    }
    return false;
  }

  function setLoading(form, isLoading) {
    const button = form.querySelector('[type="submit"]');
    if (!button) return;
    button.classList.toggle('is-loading', isLoading);
    if (isLoading) {
      button.setAttribute('aria-busy', 'true');
      button.disabled = true;
    } else {
      button.removeAttribute('aria-busy');
      button.disabled = false;
    }
  }

  function showError(form, message) {
    const errorEl = form.querySelector('[data-ctr-mba-atc-error]');
    if (!errorEl) return;
    errorEl.textContent = message;
    errorEl.hidden = !message;
  }

  function addToCart(form) {
    setLoading(form, true);
    showError(form, '');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 404 || data.status === 422) {
          showError(form, data.description || data.message || 'Error adding to cart');
          return;
        }

        if (!openCartDrawer()) {
          window.location.href = '/cart';
        }
      })
      .catch(() => {
        showError(form, 'Error adding to cart');
      })
      .finally(() => {
        setLoading(form, false);
      });
  }

  function initForm(form) {
    if (form.dataset.ctrMbaAtcReady === 'true') return;
    form.dataset.ctrMbaAtcReady = 'true';
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      addToCart(form);
    });
  }

  function initAll(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(FORM_SELECTOR).forEach(initForm);
  }

  function init() {
    initAll(document);

    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
      document.addEventListener('shopify:section:load', (event) => {
        const section = event.target.querySelector
          ? event.target.querySelector(SECTION_SELECTOR)
          : null;
        initAll(section || event.target);
      });

      document.addEventListener('shopify:block:select', (event) => {
        initAll(event.target);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
